module.exports = __webpack_public_path__ + "static/media/flower-pot.cc04ed35.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flower-pot.svg
// module id = 171
// module chunks = 0